import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditExecutionTimes',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      weekDayOptions: [{
        value: this.$i18n_t('Common.AllDays'),
        text: this.$i18n_t('Common.AllDays')
      }, {
        value: 1,
        text: this.$i18n_t('Common.Monday')
      }, {
        value: 2,
        text: this.$i18n_t('Common.Tuesday')
      }, {
        value: 3,
        text: this.$i18n_t('Common.Wednesday')
      }, {
        value: 4,
        text: this.$i18n_t('Common.Thursday')
      }, {
        value: 5,
        text: this.$i18n_t('Common.Friday')
      }, {
        value: 6,
        text: this.$i18n_t('Common.Saturday')
      }, {
        value: 0,
        text: this.$i18n_t('Common.Sunday')
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule() {
      return [v => !!v || parseInt(v) === 0 || this.$i18n_t('Common.fieldRequired')];
    },
    hourRules() {
      return [...this.requiredRule, v => v >= 0 && v <= 23 || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRule')];
    },
    minuteRules() {
      return [...this.requiredRule, v => v >= 0 && v <= 59 || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.minuteRule')];
    },
    executionTimes() {
      return (get(this.rule, 'properties.executionTimes') || []).filter(t => {
        return !!get(t, 'startTime') && t.startTime.constructor === Object;
      });
    },
    hourRuleEveryX() {
      return [...this.requiredRule, v => v > 0 || this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRuleEveryX')];
    },
    monthDaysOptions() {
      const monthDays = Array.from({
        length: 31
      }, (idx, i) => i + 1);
      monthDays.unshift(this.$i18n_t('Common.AllDays'));
      return monthDays;
    }
  },
  methods: {
    startDatePicked(dateObject, i) {
      this.rule.properties.executionTimes[i].dateStart = new Date(dateObject.from * 1000).toISOString();
      this.refreshExecutionTimes();
    },
    endDatePicked(dateObject, i) {
      this.rule.properties.executionTimes[i].dateEnd = new Date(dateObject.from * 1000).toISOString();
      this.refreshExecutionTimes();
    },
    refreshExecutionTimes() {
      this.$emit('refresh-form');
    },
    handleDaysSelection(executionIndex, property) {
      const days = this.executionTimes[executionIndex][property] || [];
      if (days.includes(this.$i18n_t('Common.AllDays'))) {
        if (days.indexOf(this.$i18n_t('Common.AllDays')) === days.length - 1) {
          this.rule.properties.executionTimes[executionIndex][property] = [this.$i18n_t('Common.AllDays')];
        } else {
          this.rule.properties.executionTimes[executionIndex][property] = days.filter(day => day !== this.$i18n_t('Common.AllDays'));
        }
      }
    }
  }
};